import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  leftPanelContainer: {
    width: 300,
    borderWidth: 19,
  },
}));
